// extracted by mini-css-extract-plugin
module.exports = {"points_activity":"PointsActivity_points_activity__I_7Ro"};